import type { ComponentProps } from 'react';
import { BaseCheckbox as BaseCheckbox, useCheckboxState } from 'src/app/_components/base/checkbox';
import { cn } from 'src/app/lib/utils/tailwindcss';

export type CheckboxProps = ComponentProps<typeof BaseCheckbox> & { size?: number };

const KottonseedCheckbox = ({ checked, defaultChecked, disabled, className, size = 24, ...props }: CheckboxProps) => {
  return (
    <BaseCheckbox
      checked={checked}
      defaultChecked={defaultChecked}
      disabled={disabled}
      className={cn(`size-${size / 4}`, className)}
      {...props}
    >
      <CheckboxIcon size={size} />
    </BaseCheckbox>
  );
};

const ICON_STYLE = {
  default: {
    fill: 'none',
    circleStroke: '#D3D3D3',
    checkStroke: '#D3D3D3',
  },
  checked: {
    fill: '#8424EA',
    circleStroke: 'none',
    checkStroke: '#fff',
  },
  disabled: {
    fill: '#D3D3D3',
    circleStroke: 'none',
    checkStroke: '#F0F0F0',
  },
};

const CheckboxIcon = ({ size = 24 }: { size?: number }) => {
  const { isChecked, isDisabled } = useCheckboxState();
  const style = isDisabled ? ICON_STYLE.disabled : isChecked ? ICON_STYLE.checked : ICON_STYLE.default;

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="9.25" fill={style.fill} stroke={style.circleStroke} strokeWidth="1.5" />
      <path
        d="M7.5 12L10.5 15L16.5 9"
        stroke={style.checkStroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default KottonseedCheckbox;
